<ng-container *ngIf="resources.includes('*') && !cameras.length && !isLoading">
  <mat-card class="allCameras"
    >{{ 'users.policyGroups.managePoliciesAllCamerasSelected' | t }} <sn-icon fontSet="fal" fontIcon="fa-circle-check"></sn-icon
  ></mat-card>
</ng-container>
<ng-container *ngIf="!resources.includes('*') && cameras.length && !isLoading">
  <mat-card class="mat-elevation-z2" *ngFor="let camera of cameras">
    {{ camera.name }}
  </mat-card>
</ng-container>
<ng-container *ngIf="!resources.includes('*') && !cameras.length && isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
